import { useApiGet } from '@sierralabs/core-ui';
export function useFindEntityDataById(idOrTable, id, version) {
    const ver = typeof version === 'number' ? `/version/${version}` : '';
    const { data, isLoading, error, get } = useApiGet(`entities/${idOrTable}/data/${id}${ver}`);
    return {
        entityData: data,
        isLoading,
        loadingError: error,
        getEntityDataById: get
    };
}
//# sourceMappingURL=useFindEntityDataById.js.map